export default "__VITE_ASSET__CMYqqmTr__"